module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-left-circle-adf31d89.svg";